export default __webpack_public_path__ + "static/media/awards-orange-icon.36d89ea7.svg";